import { Grid } from "@mui/material";
import SmartPredictSvg from "SvgIcons/SmartPredictSvg";
import CloseIcon from "@mui/icons-material/Close";
import { observer } from "mobx-react";
import { Tag } from "models/Tag";
import React from "react";
import { Divider } from "@mui/material";
import AIExplanationCard from "./AIExplanationCard";
import { useStore } from "utils/useStore";
import { EvalStore } from "components/Evaluation/Stores/EvalStore";
import { PredictedTag } from "models/PredictedTag";
import { Answer } from "models/Answer";
import { AcxLLMSmartPredictIcon } from "SvgIcons/AcxLLMSmartPredictIcon";

interface AIExplanationCardsProps {
    activeTags: Tag[];
    predictedTags: PredictedTag[];
    answer: Answer;
    questionId: string;
}

const AIExplanationCards = observer((props: AIExplanationCardsProps) => {
    const store = useStore(EvalStore);

    const tagIdToPredictedTags = React.useMemo(() => {
        const result: Record<string, PredictedTag[]> = {};
        for (const predictedTag of props.predictedTags) {
            if (!result[predictedTag.tagId])
                result[predictedTag.tagId] = [predictedTag];
            else result[predictedTag.tagId].push(predictedTag);
        }
        return result;
    }, [props.predictedTags]);

    return (
        <Grid sx={{ marginTop: "0.25rem", paddingInline: 3, maxWidth: "100%" }}>
            <Grid
                container
                direction="column"
                sx={{
                    backgroundColor: (t) => t.palette.neutralGray.main,
                    borderRadius: 1,
                    border: "1px solid #E5E7EB",
                }}
            >
                <Grid
                    container
                    item
                    direction="row"
                    justifyContent="space-between"
                    sx={{ padding: 1.25 }}
                >
                    {props.answer.hasLLMPrediction ? (
                        <AcxLLMSmartPredictIcon />
                    ) : (
                        <SmartPredictSvg />
                    )}
                    <CloseIcon
                        sx={{ color: "#A1A1AA", cursor: "pointer" }}
                        fontSize={"small"}
                        onClick={() =>
                            store.setShowAIExplanation(props.questionId, false)
                        }
                    />
                </Grid>
                {props.activeTags
                    .filter(
                        (tag) =>
                            Object.hasOwn(tagIdToPredictedTags, tag.id) &&
                            tagIdToPredictedTags[tag.id].length > 0,
                    )
                    .map((tag, index) => (
                        <React.Fragment key={tag.id}>
                            {index > 0 && <Divider />}
                            <Grid item sx={{ maxWidth: "100%" }}>
                                <AIExplanationCard
                                    activeTag={tag}
                                    predictedTags={tagIdToPredictedTags[tag.id]}
                                    answer={props.answer}
                                />
                            </Grid>
                        </React.Fragment>
                    ))}
            </Grid>
        </Grid>
    );
});

export default AIExplanationCards;
